// Card label for a document: Hindi reads "<title> बनाये", everything else "Create <title>".
export const docCardTitle = (doc) =>
  doc?.languageCode === "HIN"
    ? `${doc.name_title} बनाये`
    : `Create ${doc?.name_title}`;
